import { render } from "./addpettycashout.vue?vue&type=template&id=2968e0d9&scoped=true"
import script from "./addpettycashout.vue?vue&type=script&lang=js"
export * from "./addpettycashout.vue?vue&type=script&lang=js"

import "./addpettycashout.vue?vue&type=style&index=0&id=2968e0d9&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2968e0d9"]])

export default __exports__